export default "__VITE_ASSET__DbUMoNUM__ 480w, __VITE_ASSET__xXeg6jfQ__ 800w, __VITE_ASSET__DODLkA_8__ 1200w, __VITE_ASSET__DfFax1T9__ 1456w";